import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ServicesPage from '../pages/services/page';
import ServiceDetailPage from '../pages/services/detail/page';
import AboutPage from '../pages/about/page';
import LocationsPage from '../pages/locations/page';
import LocationDetailPage from '../pages/locations/detail/page';
import ContactPage from '../pages/contact/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/services/:slug', element: <ServiceDetailPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/locations', element: <LocationsPage /> },
  { path: '/locations/:slug', element: <LocationDetailPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
